import { render } from "./SimCard.vue?vue&type=template&id=1daf9c60&scoped=true"
import script from "./SimCard.vue?vue&type=script&lang=js"
export * from "./SimCard.vue?vue&type=script&lang=js"

import "./SimCard.vue?vue&type=style&index=0&id=1daf9c60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1daf9c60"]])

export default __exports__